module.exports = __webpack_public_path__ + "static/media/sleeveless.c0040151.jpg";